module.exports = __webpack_public_path__ + "img/cgreen.15933a97.png";